var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("RailwayExport.ReturnContainer"),
        width: "370px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "app-main-row" },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "80px", "label-position": "left" } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("RailwayExport.ReturnBoxDate") + ":" }
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.returnBoxDate,
                      callback: function($$v) {
                        _vm.returnBoxDate = $$v
                      },
                      expression: "returnBoxDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { display: "flex" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "div",
            { staticStyle: { margin: "0 auto" } },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "Confirm", type: "primary" },
                  on: { click: _vm.successHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "Cancel" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }